import React from 'react';
import AccordionSingle from './accordionContent/accordionContent';
import ExpandPanel from '../../components/expandPanel/expandPanel';
import Link from '../../components/link/link';
import ModuleWrapper from '../../globals/moduleWrapper/moduleWrapper';

const Accordion = ({data, accordionlink, className, ...other}) => {
  // console.log(accordionlink);
  return (
    <ModuleWrapper className={`accordion ${className || ''}`} {...other}>
      {
        data?.map((accordion,i)=>{
          let {heading, ...content} = accordion;
          return  <ExpandPanel panelClassName={`accordion__single`} startOpen={i === 0 ? true : false} key={i} uniqueid={i} buttonContent={accordion.heading} closeOutsideClick={false} className={'btn--accordion'}>
                    <AccordionSingle uniqueid={className+i} data={content} />
                  </ExpandPanel>
        })
      }
      {
        accordionlink && <div className={`accordion__linkwrap`}><Link data={accordionlink} className="btn--primary"/></div>
      }
    </ModuleWrapper>
  );
};


export default Accordion;
